// scheduling/components/ContractChip.jsx
// The staffer's contract (FT / PT / Flex / Leave + weekly hours) as a small chip, so a
// manager scheduling in bulk can see who is part-time without opening every profile.
//
// Madison May, 2026-11: "Is there a way to know peoples' part-time capacities without
// emailing/messaging everyone?" — the capacity number alone didn't say, and in busy
// season it was wrong (fixed in resolveEffectiveTemplate).
//
// Renders nothing for a plain full-timer unless `showFullTime` — full time is the norm,
// and a chip on every row would bury the exceptions it exists to surface.

const MD = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const fmtMD = (md) => {
  if (!md) return '';
  const [m, d] = md.split('-').map(Number);
  return `${MD[m] || ''} ${d}`;
};

export function contractTitle(contract) {
  if (!contract) return '';
  const lines = [`${contract.name} — ${contract.weeklyHours}h/week`];
  for (const s of contract.seasonal || []) {
    const when = s.start && s.end ? ` ${fmtMD(s.start)}–${fmtMD(s.end)}` : '';
    lines.push(`${s.name}: ${s.weeklyHours}h/week${when}`);
  }
  if (!contract.fullTime && !(contract.seasonal || []).length) lines.push('Not raised in busy season');
  return lines.join('\n');
}

/**
 * @param {object} contract  resolveContract() result, or null
 * @param {boolean} showFullTime  render the chip for full-timers too
 * @param {string} className  extra placement class (e.g. the grid's staff-card corner)
 */
export default function ContractChip({ contract, showFullTime = false, className = '', style }) {
  if (!contract) return null;
  if (contract.kind === 'FT' && !showFullTime) return null;
  return (
    <span className={`sched-contract-chip sched-contract-chip--${contract.kind.toLowerCase()}${className ? ` ${className}` : ''}`}
      title={contractTitle(contract)} style={style}>
      {contract.label}
    </span>
  );
}
